import { defineStore, storeToRefs } from "pinia";
import api from "@/services/api";
import { useSessionStore, useSitesStore } from "@/stores";
import DataSeriesBySite from "@/models/frontend/DataSeriesBySite";
import DataSeriesByLabel from "@/models/frontend/DataSeriesByLabel";
import IDataSeriesBySite from "@/models/responses/IDataSeriesBySite";
import IDataSeriesByLabel from "@/models/responses/IDataSeriesByLabel";

export const useBusinessIntelligenceStore = defineStore("businessIntelligence", {
  state: () => ({
    error: "" as any,
    expiryDates: undefined as DataSeriesBySite[] | undefined,
    itemIssues: undefined as DataSeriesByLabel[] | undefined,
  }),
  actions: {
    async fetchExpiryDates() {
      const sessionStore = useSessionStore();
      const {selectedSiteId} = storeToRefs(sessionStore);

      this.error = "";
      await api
        .get<IDataSeriesBySite[]>(`v1.0/statistics/shelfLife?siteId=${selectedSiteId.value}`)
        .then((response) => this.expiryDates = response.data.map(stat => this.mapToFrontend(stat)))
        .catch((error) => (this.error = error));
    },
    async fetchItemIssues() {
      const sessionStore = useSessionStore();
      const {selectedSiteId} = storeToRefs(sessionStore);

      this.error = "";
      await api
        .get<IDataSeriesByLabel[]>(`v1.0/statistics/itemIssues?siteId=${selectedSiteId.value}`)
        .then((response) => this.itemIssues = response.data.map(stat => mapUpLabel(stat)))
        .catch((error) => (this.error = error));
    },
    mapToFrontend(dataSeriesBySite: IDataSeriesBySite) {
      const site = useSitesStore().getById(dataSeriesBySite.siteId);
      return new DataSeriesBySite(
        site,
        dataSeriesBySite.values
      );
    },
  }
});

const mapUpLabel = (value: IDataSeriesByLabel) => {
  return new DataSeriesByLabel(
    value.label,
    value.values
  );
};
